import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { bannerService } from '../../api/services';
import useBannerLink from '../../hooks/useBannerLink';

/**
 * 서비스별 고정 광고 배너 (2026-06 개편 — 기존 슬라이딩 3열 갤러리 대체).
 * - 서비스(airport/golf/...) + 현재 언어에 맞는 배너 1장을 조회해 고정 노출.
 * - 데스크탑(≥1024px) = image_url(3:1), 모바일 = image_mobile_url(4:3, 없으면 데스크탑 폴백).
 * - link_url 있으면 클릭 시 기존 배너 링크 규칙(coupon/signup/외부/내부) 적용.
 * - 배너 미등록 시 아무것도 렌더하지 않음(미노출).
 */
export default function ServiceBanner({ service }) {
  const { t } = useTranslation();
  const [banner, setBanner] = useState(null);
  const { onBannerLink, couponModal } = useBannerLink();

  useEffect(() => {
    let alive = true;
    if (!service) { setBanner(null); return undefined; }
    bannerService.getServiceBanner(service)
      .then((b) => { if (alive) setBanner(b); })
      .catch((e) => { if (alive) setBanner(null); console.warn(e?.message); });
    return () => { alive = false; };
  }, [service]);

  if (!banner || !banner.image_url) return null;

  const desktop = banner.image_url;
  const mobile = banner.image_mobile_url || banner.image_url;
  const alt = banner.title || (service ? t(`service.${service}`) : '') || 'VIP Van Tour';

  const img = (
    <picture>
      {/* 데스크탑(≥1024px)은 가로 배너, 그 외(모바일/태블릿)는 모바일 배너(없으면 데스크탑). */}
      <source media="(min-width: 1024px)" srcSet={desktop} />
      {/* 검색카드와 동일한 카드 톤(라운드+소프트 그림자+얇은 테두리)으로 프레이밍 → 날것 느낌 제거 */}
      <img src={mobile} alt={alt} loading="lazy" className="w-full h-auto rounded-2xl shadow-card ring-1 ring-black/5" />
    </picture>
  );

  // 배너가 있을 때만 section(여백 포함) 렌더 → 미등록 서비스에선 빈 공간 없음.
  return (
    <section className="max-w-content mx-auto px-4 sm:px-5 pt-0 pb-6 sm:pb-8">
      {banner.link_url ? (
        <button
          type="button"
          onClick={() => onBannerLink(banner.link_url)}
          className="block w-full text-left cursor-pointer"
        >
          {img}
        </button>
      ) : img}
      {couponModal}
    </section>
  );
}
